export enum Scenario {
  introduction = 'introduction',
  questions = 'questions',
  success = 'success',
  results = 'results',
}
